let content = [
    {
      id: "general_trading_conditions",
      title: "Ogólne warunki handlowe",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Szczegóły produktu",
          content_before: `<p class="mb-5">
                          iFOREX Europe oferuje bardzo konkurencyjne warunki dla następujących instrumentów finansowych („Instrumenty finansowe” lub „Instrumenty”) (i) handel instrumentami finansowymi/aktywami bazowymi z dźwignią finansową („Aktywa bazowe”), w tym pary walutowe (Forex), surowce, indeksy, akcje , ETF i Crypto oparte na kontraktach CFD („Instrumenty lewarowane” lub „CFD”).
                          <br><br>
                          <b>Spready</b><br>Koszt otwarcia transakcji nazywa się "spread". Jest to różnica między ceną Sprzedaj (Bid), a ceną Kup (Ask). Na przykład, jeśli USD/JPY ma cenę sprzedaży 101,222 i cenę kupna 101,222, różnica między tymi dwoma cenami nazywa się spreadem. W tym przypadku spread wynosi 2 pipsy. Jeśli podejmiesz decyzję o zamknięciu transakcji natychmiast po jej otwarciu - a przed wystąpieniem jakichkolwiek zmian cen - kwota spreadu zostanie odjęta od Twojego salda.
                          <br><br>
                          <b>Marża i dźwignia</b><br>Depozyt zabezpieczający stanowi zabezpieczenie potencjalnych strat. Pozwala również na otwieranie pozycji na znacznie większe kwoty niż pozwala na to faktyczna wartość na koncie. Daje to inwestorom możliwość osiągania zysków znacznie wyższych, niż te możliwe do osiągnięcia tylko za pomocą zainwestowanej kwoty.
                          <br><br>
                          Dźwignia jest jednak jak kij, który zawsze ma dwa końce. Z jednej strony dzięki temu mechanizmowi można pomnożyć zyski, z drugiej jednak strony straty również są większe. Jeśli parametry zastosowanej dźwigni są zbyt wysokie, straty mogą w krótkim czasie przewyższyć zyski z handlu. Handel przy zastosowaniu dźwigni obciążony jest wysokim ryzykiem i może nie być odpowiedni dla wszystkich inwestorów.
                          <br><br>
                          Jesteś posiadaczem konta na iFOREX Europe, a więc masz dostęp do programu Ochrony przed ujemnym bilansem. Oznacza to, że nigdy nie poniesiesz straty przekraczającej wartość złożonego depozytu. Nasza platforma transakcyjna automatycznie określa wymagania dotyczące depozytu zabezpieczającego przed realizacją zlecenia oraz sprawdza poziom dostępnych środków przed przetworzeniem wniosku o wypłatę środków.
                          <br><br>
                          Wymóg depozytu zabezpieczającego odnosi się do wzrostu zaangażowania środków na koncie, zarówno przy otwieraniu/zamykaniu transakcji, jak i przy wnioskowaniu o wypłatę funduszy, gdy na koncie są otwarte pozycje.
                          </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Waluty</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Surowce</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indeksy</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Akcje</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETF</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Krypto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Godziny handlu",
          content_before: `<p>
              Podczas europejskiej i północnoamerykańskiej zimy, aktywność w tygodniu zaczyna się w niedzielę o 22:05 GMT w sposób ciągły aż do piątku do 21:00 GMT. W czasie Day Light Saving w tych regionach, w tygodniu aktywność na rynku zaczyna się w niedzielę o 21:05 GMT i kończy się w piątek o godzinie 20:00. Godziny aktywności na rynku mogą się zmieniać ze względu na święta lub z powodu nietypowych warunków płynnościowych, które mogą wynikać z wyjątkowych wydarzeń światowych. Czas otwarcia lub zamknięcia może być również zmieniony przez iFOREX Europe ze względu na płynność i zarządzanie ryzykiem.
              <br><br>
              Chociaż większość instrumentów handlowane jest przez 24 godziny na dobę, niektóre instrumenty mają specjalne godziny handlu, jak widać w poniższej tabeli:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Waluty I Krypto",
            2:"Surowce",
            3:"Indeksy",
            4:"Akcje",
            5:"Precious Metals Spot",
            8:"ETF"
          },
          table_titles: [
            "Rynek",
            "Godziny Handlu (GMT)",
            "Pierwsza codzienna przerwa (GMT)",
            "Druga codzienna przerwa (GMT)",
            "Dane ważne do (GMT)"
          ],
          content_after: `<p>Nie wiesz, który rynek obejmuje instrument, którego szukasz? Kliknij tutaj, aby wyświetlić pełną <span class="tclink" target-tab="tc-view-6">listę instrumentów na rynku</span>.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Święta",
          content_before: `<p>
              Aby upewnić się, że znasz wszystkie godziny rynkowe i święta, poniżej zamieszczamy wykaz wydarzeń, które mogłyby zmienić godziny handlu.<br>
              W iFOREX Europe robimy, co w naszej mocy, aby te informacje były udostępniane na bieżąco.<br>
              Jeśli chcą Państwo uzyskać więcej informacji prosimy o kontakt z naszym Centrum Operacyjnym.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Rynek",
            "Handel wstrzymany o (GMT)",
            "Handel wznowiony o (GMT)",
          ],
          content_after: `<p class="mt-4">Nie wiesz, który rynek obejmuje instrument, którego szukasz? Kliknij tutaj, aby wyświetlić pełną <span class="tclink" target-tab="tc-view-6">listę instrumentów na rynku</span>.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Zamówienia i realizacja",
          content_before: `<p><b>Rodzaje zleceń</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>Zlecenia Rynkowe</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Otwórz transakcje</td>
                   <td>Aby otworzyć pozycję po aktualnym kursie rynkowym</td>
                </tr>
                <tr>
                   <td>Zamknij transakcje</td>
                   <td>Aby zamknąć pozycję po aktualnym kursie rynkowym</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>Limity zleceń</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>Stop Loss to zlecenie otwarcia lub zamknięcia transakcji po kursie niższym niż aktualny kurs rynkowy</td>
                </tr>
                <tr>
                   <td>Pobierz Zysk</td>
                   <td>Pobierz Zysk to zlecenie otwarcia lub zamknięcia transakcji po kursie wyższym niż aktualny kurs rynkowy</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Zlecenia Rynkowe</b><br>Zlecenia rynkowe (zlecenie handlu, czyli otwarta transakcja, zamknięta transakcja) są realizowane po cenie, która jest w rzeczywistości na Platformie Handlowej Spółki (po stronie klienta) w dokładnym czasie realizacji, pod warunkiem, że taka cena jest w obrębie określonego poziomu tolerancji cen bazowych aktualizowanych na serwerach Spółki i niezależnie, czy cena bazowa jest powyżej czy poniżej ceny zaktualizowanej na platformie handlowej (What You See Is What You Get lub WYSIWYG). W przypadku, gdy cena zaktualizowana na platformie transakcyjnej (po stronie klienta) przekracza powyższy poziom tolerancji, na przykład, z powodu zmian w aktywach bazowych pomiędzy czasem, kiedy klient umieszcza swoje zlecenie a czasem jego otrzymania i realizacji, wysokiej zmienności rynkowej i opóźnienia w komunikacji, Zlecenie zostanie zrealizowane po cenie aktualizowanej na serwerach Spółki, które będą się różnić od ceny aktualizowanej na platformie transakcyjnej (cena rynkowa), na podstawie symetrycznej. W przypadku znacznej różnicy między ceną aktualizowaną na platformie transakcyjnej (po stronie klienta), a ceną aktualizowaną na serwerach Spółki, zamówienie zostanie odrzucone.
          </p>
          <p>
             <b>Limity zleceń</b><br>Limity zleceń (przyszłych zamówień) są realizowane po cenie rynkowej, aktualizowanych na serwerach Spółki, która może być różna od ceny wskazanej w zamówieniu ("Spadek"). Poślizg może wystąpić w przypadku, kiedy wskazana cena nie jest dostępna na serwerach, na przykład, ze względu na dużą zmienność i luki w cenach rynkowych. W takim wypadku, zlecenie zostanie zrealizowane w pierwszej dostępnej cenie, niezależnie od kierunku poślizgu, albo korzyści klienta, czy nie, w sposób przejrzysty i symetryczny (Symmetrical Slippage).<br><br>Instrumenty (np akcje i indeksy), które nie są przedmiotem obrotu na podstawie 24 godzin, mogą odnotowywać luki rynkowe, na co dzień, a zatem są bardziej podatne na poślizg. Ważne jest, aby pamiętać, że poślizg nie wpływa na ochronę przed negatywnym bilansem i dlatego klient nigdy nie stracić więcej niż kwota zainwestowana (w tym jakikolwiek zysk, jeśli uzyskany), nawet, jeśli wystąpi poślizg.<br><br>Uwaga: jeśli klient ustanowi zlecenie z limitem na swoich otwartych transakcjach, niektóre lub wszystkie transakcje mogą zostać automatycznie zamknięte przed osiągnięciem odpowiednich Zleceń Limitowych, z uwagi na obowiązkowy mechanizm Close-out Protection. Aby uzyskać więcej informacji na temat Ochrony przed Margin Close-Out , zapoznaj się z zakładką "Informacje o Marżach" poniżej.
          </p>
          <p>
             <b>Opóźnienia w wykonaniu</b><br>Opóźnienie w realizacji może nastąpić z różnych powodów, takich jak problemy techniczne z klienta Internetem, telefonem lub innym połączeniem komunikacyjnym z serwerami iFOREX Europe, co może powodować "wiszące zamówienia". Zakłócenia na ścieżce połączenia mogą czasem przerywać sygnał i wyłączyć platformę powodując opóźnienia w transmisji danych pomiędzy platformą przedsiębiorcy i serwerem iFOREX Europe.
          </p>
          <p>
             <b>Wiszące Zamówienia</b><br>W okresach handlu o dużym nasileniu wolumenu oraz opóźnieniach komunikacyjnych możliwe jest, że powstanie kolejka Limitów Zleceń. To zaś powoduje wzrost przychodzących zleceń, co może stworzyć warunki, w których występują opóźnienia w potwierdzeniu / przetworzeniu konkretnych Limitów Zleceń. W niektórych przypadkach pozycja mogła zostać wykonana a opóźnienie jest tylko na wyświetlaczu po stronie klienta z powodu dużego obciążenia Internetowego.<br><br>Należy pamiętać, że konieczne jest wprowadzenie dowolnego zlecenia tylko raz. Wielokrotne wprowadzanie tej samej pozycji, może spowolnić lub zablokować komputer lub przypadkowo otworzyć niepotrzebne pozycje.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Ochrona Przed Negatywnym Bilansem",
          content_before: `<p>
                          iFOREX Europe Ochrona przez Negatywnym Bilansem gwarantuje, że straty klienta są ograniczone do środków zainwestowanych na rachunku klienta. Zgodnie z tą polityką, klient nigdy nie ma do czynienia z debetem z powodu strat handlowych podczas handlu z iFOREX Europe i potencjalna strata klienta jest ograniczona do środków zdeponowanych na rachunku Klienta oraz środków pozyskanych przez klienta, jeśli w ogóle.
                            </p>`,
          data_id: "",
          content_after: "",
        },

{
  //id: "margin_information",
  id: "tc-view-24",
  title: "Informacje o marży",
  content_before: `
    <p>
      Okno wyświetlone poniżej zawiera szczegółowe informacje dotyczące marży na koncie:
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Kapitał</td>
              <td>€4 995</td>
            </tr>
            <tr>
              <td>Używana Marża</td>
              <td>€2 500</td>
            </tr>
            <tr>
              <td>Dostępna Marża</td>
              <td>€2 495</td>
            </tr>
            <tr>
              <td>Wykorzystanie Marży</td>
              <td style="color:green">50,05%</td>
            </tr>
            <tr>
              <td>Obowiązkowa Marża</td>
              <td>€1 250</td>
            </tr>
            <tr>
              <td>Zaangażowanie Netto </td>
              <td>€250 000</td>
            </tr>
            <tr>
              <td>Pokrycie Zaangażowania</td>
              <td>1498%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
          <b>Kapitał</b> odzwierciedla bieżącą wartość Twojego konta. Obejmuje on saldo oraz zyski/straty z otwartych pozycji.
        </li>

        <li>
          <b>Używana Marża</b> pokazuje kwotę kapitału na koncie, która jest obecnie wykorzystywana jako marża dla Twoich otwartych transakcji. W przypadku gdy Używana Marża jest równa lub większa niż kapitał, oznacza to, że dźwignia na koncie została maksymalnie wykorzystana.
        </li>

        <li>
          <b>Dostępna Marża</b> pokazuje kwotę kapitału na koncie, która nie jest obecnie wykorzystywana i jest dostępna do dalszego zwiększenia zaangażowanie  netto. W przypadku gdy Dostępna Marża  wynosi zero, oznacza to maksymalne wykorzystanie dźwigni na koncie.<br>
          Dostępna Marża = Kapitał – Używana Marża
        </li>

        <li>
          <b>Wykorzystanie Marży</b> pokazuje procent kapitału, który jest wykorzystywany jako Marża dla aktualnie otwartych transakcji na koncie. 100% Wykorzystanie Marży lub więcej oznacza maksymalne wykorzystanie dźwigni.<br>
           Wykorzystanie Marży % = (Używana Marża/Kapitał) x 100
        </li>

        <li>
          <b>Obowiązkowa Marża</b> jest równa 50% Używanej Marży wymaganej do utrzymania otwartych transakcji. Jeśli Kapitał spadnie do tego poziomu lub poniżej, Ochrona Margin Close-Out (zgodnie z definicją poniżej) automatycznie zostanie uruchomiona.<br>
          Obowiązkowa Marża = Używana Marża x 0,5
        </li>

        <li>
          <b>Pokrycie Zaangażowania</b> to procent  zaangażowania pokryty własnymi środkami. Odnosi się do maksymalnej zmiany ceny rynkowej przeciwnej do kierunku otwartych transakcji, która jest pokryta środkami do osiągnięcia Obowiązkowej Marży).<br>
          Pokrycie Zaangażowania = (Kapitał -Obowiązkowa Marża)/Zaangażowanie Netto 
        </li>
      </ul>

      <b>Ochrona Margin Close-Out </b><br>
      Jeżeli środki dostępne w Kapitale klienta będą równe lub spadną poniżej poziomu  Obowiązkowej Marży, iFOREX Europe automatycznie zamknie transakcję, która wykorzystuje największą kwotę Używanej Marży, w celu osiągnięcia możliwie najniższej Obowiązkowej Marży  (zamykając tylko otwarte transakcje na instrumentach, które są w tym czasie dostępne do handlu zgodnie z opublikowanymi godzinami handlu). Jeżeli w danym momencie nie ma otwartych transakcji na dostępnych instrumentach, transakcja na instrumencie, który jako pierwszy otrzyma notowanie, zostanie zamknięta w pierwszej kolejności. Jeśli istnieje wiele transakcji (więcej niż jedna), które w równym stopniu wykorzystują największą kwotę Używanej Marży, Spółka zamknie transakcję otwartą jako pierwsza. W przypadku gdy osiągnięcie najniższej możliwej Obowiązkowej Marży nie jest możliwe poprzez automatyczne zamknięcie pojedynczej transakcji, Spółka zamknie wszystkie otwarte transakcje w ramach danego instrumentu. iFOREX Europe umożliwia klientom pełne wykorzystanie niezrealizowanych zysków z ich otwartych transakcji w celu wsparcia transakcji przynoszących straty.
      <br><br>

      <b><u><u>Przykłady</u></u></b><br><br>

      <b>Przykład I</b><br>
      Ten przykład dotyczy sytuacji, w której klient posiada kilka otwartych transakcji, a Kapitał na koncie osiąga poziom równy lub niższy od Obowiązkowej Marży:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Otwarte transakcje:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 transakcja EUR/USD: KUPNO €60 000 po kursie 1,1750 (wymagana początkowa Używana Marża = 3,33% x €60 000 = €1 998)</li>
          <li>1 transakcja Germany 40: KUPNO 4 kontraktów po kursie 12 500 (wymagana początkowa Używana Marża = 5% x 4 x €12 500 = €2 500)</li>
          <li>1 transakcja Ropa WTI: KUPNO 500 baryłek po kursie 70,00 lub 59,56 za baryłkę w przypadku wyceny w euro (wymagana początkowa Używana Marża= 10% x 500 x €59,56 = €2 978)</li>
        </ul>
        <li>Używana Marża = €1 998 + €2 500 + €2 978 = €7 476</li>
        <li>Poziom Obowiązkowej Marży = €3 738</li>
      </ul>
      Gdy tylko Kapitał na koncie osiągnie poziom równy lub niższy niż €3 738, Ochrona Margin Close-Out  zostanie uruchomiona poprzez zamknięcie transakcji wykorzystującej największą Używaną Marże, czyli <b>KUPNO 500 baryłek ropy WTI</b>.
      <br><br>

      <b>Przykład II</b><br>
      Ten przykład dotyczy sytuacji, w której klient posiada kilka otwartych transakcji, a kapitał na koncie osiąga poziom równy lub niższy od Obowiązkowej Marży:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Otwarte transakcje:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 transakcje USD/JPY: KUPNO $100 000 (wymagana początkowa Używana Marża = 3,33% x $100 000 = $3 330), SPRZEDAŻ $80 000 (wymagana początkowa Używana Marża = 3,33% x $80 000 = $2 664)</li>
          <li>1 transakcja USD/PLN: SPRZEDAŻ $80 000 (wymagana początkowa Używana Marża = 5% x $80 000 = $4 000)</li>
        </ul>
        <li> Używana Marża = ($3 330 – $2 664) + $4 000 = $4 666</li>
        <li>Poziom Obowiązkowej Marży = $2 333</li>
      </ul>
      Gdy tylko kapitał na koncie osiągnie poziom równy lub niższy niż $2 333, Ochrona Margin Close-Out  zostanie uruchomiona poprzez zamknięcie transakcji wykorzystującej największą Używaną Marże, czyli <b>SPRZEDAŻ $80 000 USD/PLN</b>.
      <br><br>
      Uwaga:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Zamknięcie pozycji SPRZEDAŻ $80 000 USD/JPY zwiększyłoby Zaangażowanie Netto na USD/JPY z $20 000 do $100 000, a tym samym <b>Używana Marża wzrosłaby</b> o $2 664 ⇾ ($100 000 x 3,33%) - ($20 000 x 3,33%) = $3 330 - $666 = +<u>$2 664</u></li>
        <li>Zamknięcie pozycji KUPNO $100 000 USD/JPY zwiększyłoby  Zaangażowanie Netto na USD/JPY z $20 000 do $80 000, a tym samym <b>Używana Marża wzrosłaby</b> o $1 998 ⇾ ($80 000 x 3,33%) - ($20 000 x 3,33%) = $2 664 - $666 = +<u>$1 998</u></li>
        <li>Zamknięcie pozycji SPRZEDAŻ $80 000 USD/PLN zmniejszyłoby Zaangażowanie Netto na USD/PLN z $80 000 do 0, a tym samym <b>Używana Marża zmniejszyłaby się o $4 000</b></li>
      </ul>

      <b>Przykład III</b><br>
      Ten przykład dotyczy sytuacji, w której klient posiada kilka Otwartych Transakcji, jednak osiągnięcie najniższej możliwej Obowiązkowej Marży nie jest możliwe poprzez automatyczne zamknięcie jednej transakcji:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Otwarte transakcje:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 transakcje USD/JPY: KUPNO $100 000 (wymagana początkowa Używana Marża = 3,33% x $100 000 = $3 330), SPRZEDAŻ $70 000 (wymagana początkowa Używana Marża = 3,33% x $70 000 = $2 331), SPRZEDAŻ $10 000 (wymagana początkowa Używana Marża = 3,33% x $10 000 = $333)</li>
          <li>2 transakcje USD/PLN: SPRZEDAŻ $10 000 (wymagana początkowa Używana Marża = 5% x $10 000 = $500), KUPNO $8 000 (wymagana początkowa Używana Marża = 5% x $8 000 = $400)</li>
          <li>2 transakcje USD/INR: SPRZEDAŻ $10 000 (wymagana początkowa Używana Marża = 5% x $10 000 = $500), KUPNO $7 000 (wymagana początkowa Używana Marża = 5% x $7 000 = $350)</li>
        </ul>
        <li> Używana Marża= ($3 330 – $2 331 – $333) + ($500 - $400) + ($500 - $350) = $916</li>
        <li>Poziom Obowiązkowej Marży = $458</li>
      </ul>
      W tym przypadku, gdy tylko Kapitał osiągnie poziom równy lub niższy niż $458, transakcje na koncie zostaną automatycznie zamknięte na poziomie instrumentu, w oparciu o instrument o największym Zaangażowanii Netto. W związku z tym <b>wszystkie transakcje USD/JPY</b> zostaną zamknięte.
      <br><br>
      Uwaga:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Zamknięcie dowolnej transakcji zwiększyłoby  Zaangażowanie Netto, a tym samym <b>Używana Marża wzrosłaby</b>.</li>
        <li>Zamknięcie wszystkich transakcji USD/JPY zmniejszy <b>Zaangażowania Netto</b> o $20 000, a <b>tym samym Używana Marża zmniejszyłaby się o  $666</b>, co jest większą redukcją niż zamknięcie transakcji USD/PLN (redukcja o $100) lub USD/INR (redukcja o $150).</li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
}
,
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Dodatkowe Warunki Handlowe",
          content_before: `
              <p>
              <b>Maksymalne Zaangażowanie</b><br>
              Jako środek ostrożnościowy, którego celem jest lepsze zarządzanie ryzykiem i unikanie nadmiernego zaangażowania na jednego klienta, iFOREX Europe ustanowił maksymalne ograniczenie zaangażowania netto do 50 (pięćdziesiąt) milionów złotych na klienta. iFOREX Europe postanowił również ustalić maksymalne zaangażowanie netto na każdy instrument. Aby wyświetlić maksymalne zaangażowanie dla każdego instrumentu, <span class="tclink" target-tab="tc-view-6" target-section="product_section">kliknij tutaj</span>. iFOREX Europe ma prawo, według własnego uznania, do odwołania lub zmiany takiego ograniczenia w dowolnym momencie bez uprzedzenia.
              <br><br>
              <b>Hedging</b><br>
              Hedging definiuje się, jako otwarcie dwóch transakcji na tym samym instrumencie lub aktywie bazowym w różnych kierunkach (jeden "kupuj", a drugi "sprzedaj"), w tym samym lub nie, czasie i w tej samej lub nie, ilości. iFOREX Europe uznaje transakcje hedging do celu obliczenia minimalnej marży w ujęciu narastającym lub na zasadzie "netto". Ponadto iFOREX Europe uważa zamknięcie jednej z hedgingowej transakcji, jako otwarcie nowej transakcji, której wielkość jest równa pozostałej transakcji.
              <br><br>
              <b>Netting Transakcji</b><br>
              W przypadku, gdy więcej niż jedna transakcja musi zamknąć się jednocześnie na koncie, iFOREX Europe zamknie wszystkie otwarte pozycje masowo.<br>Numer transakcji przypisany każdej zamkniętej pozycji jest ustalony na podstawie zasad FIFO. Oznacza to, że po zamknięciu pozycji pierwsza transakcja otwarta otrzyma najniższy numer transakcji a ostatnia pozycja otwarta otrzyma najwyższy numer transakcji.
              <br><br>
              <b>Nieautoryzowane praktyki handlowe</b><br>
              iFOREX Europe wspiera uczciwy handel i nie pozwala na nieuczciwe praktyki handlowe lub inne praktyki, które umożliwiają nieuczciwy handel, takie jak opóźnienia w handlu, manipulacje cenowe, manipulacje czasem lub inne praktyki, które są niezgodne z prawem i / lub są wykorzystywane, aby dać nieuczciwą przewagę. Przykładami takich rozwiązań, mogą być, ale nie wyłącznie, dowolne spośród następujących:
              <ul class="list-style-disc-small mt-3 mb-2">
                  <li>
                    <b>Skalpowanie</b> to strategia handlowa, która próbuje wykorzystać niewielkie zmiany cen. Traderzy, którzy wdrożą tę strategię, utworzą wiele pozycji krótkoterminowych, zwykle zamykając je w ciągu sekund lub minut.
                  </li>
                  <li>
                    <b>Automatyka</b> (np EA) lub handel algorytmiczny to wykorzystanie platform elektronicznych do wprowadzania zleceń handlowych z algorytmu, który wykonuje zaprogramowane instrukcje handlowe, których zmienne mogą zawierać terminy, cenę lub ilość zamówienia, lub w wielu przypadkach wszczęcie zamówienie przez "roboty", bez ingerencji człowieka.
                  </li>
                  <li>
                    <b>API Handel</b> to interfejs aplikacji, który odnosi się do handlu korzystając z oprogramowania do interakcji z innymi programami. API działa, jako pośrednik między przedsiębiorcą i rynkiem, przenosząc zlecenia i pobierając ile potrzeba informacji.
                  </li>
                  <li>
                    <b>"Wiele kont"</b> to termin odnoszący się do dwóch lub więcej kont utworzonych przez jednego klienta w celu uzyskania korzyści oferowanych przez iFOREX Europe.
                  </li>
              </ul>
              <p>W przypadku, gdy Firma ma jakiekolwiek oznaki lub podejrzenia, według własnego wyłącznego uznania, o jakiejkolwiek formie wykorzystywania, nielegalnych, nieuczciwych, nieautoryzowanych i/lub nadużyciach praktyk handlowych, wykorzystywanych w celu zapewnienia Klientowi nieuczciwej przewagi i/lub oszustwa, manipulacji lub naruszenia umów, zasad, warunków Spółki, Firma ma prawo, według własnego wyłącznego uznania i bez uszczerbku dla swoich praw wynikających z umów z klientem i obowiązującego prawa, unieważnić i anulować wszystkie transakcje znajdujących się na odpowiednich rachunkach, w tym wszystkich generowanych na nich zysków lub strat i/lub zablokować rachunek.</p>
              <b>Błędy w Kursach</b><br>
              Technologia handlu online nie jest doskonała i w rzadkich przypadkach może być zakłócona. Może to trwać tylko przez chwilę, ale takie sytuacje mogą mieć wpływ na cenę. Chociaż może to być kuszące, aby umieścić "arbitrage transaction", należy pamiętać, że w takich sytuacjach ceny nie są prawdziwe a rzeczywiste mogą być w odległości wielu pipsów od wyświetlanej ceny. W przypadku, gdy transakcje realizowane są w cenach nieoferowanych w rzeczywistości przez iFOREX Europe,iFOREX Europe zastrzega sobie prawo do unieważnienia takich transakcji, ponieważ nie uznaje się ich za ważne. Należy pamiętać, że te przypadki są zazwyczaj rzadkie, a poprzez nie składanie zamówień na rynku lub unikanie handlu w takim momentach uchronisz się przed ryzykiem związanym z powyższym scenariuszem.
              <br><br>
              <b>Opłata za utrzymanie</b><br>
              Rachunki klientów, na których nie było żadnej aktywności handlowej przez okres dwunastu (12) kolejnych miesięcy zostaną obciążony opłatą kwartalną 15 $ lub całym kapitałem własnym konta w razie, gdy bilans konta jest mniejszy niż 15 $.<br>Jeśli klient nie ma żadnych dostępnych środków na rachunku iFOREX Europe opłata za utrzymanie nie zostanie pobrana.
              <br><br>
              Po więcej informacji na temat handlu, zobacz nasze <a href="/legal/client-agreement.pdf">Warunki Handlowe</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Nocne Finansowanie",
          content_before: `
                  <p>
                  Podczas handlu dźwignią na Forex CFD z firmą iFOREX Europe, otwarte transakcje podlegają Nocnemu Finansowaniu pod koniec każdego dnia handlowego. Nocne Finansowanie, może powodować zwiększenie lub zmniejszenie kwoty i obliczane jest na podstawie odpowiednich stóp procentowych walut, w których instrument bazowy jest przedmiotem obrotu, plus mark-up. Mark-up dla par walutowych zaczyna się od 0,75% i może być wyższy, a także różnić się między pozycjami Długimi (Kup) i Krótkimi (Sprzedaj). Zapoznaj się z poniższą tabelą, aby poznać najnowsze poziomy Nocnego Finansowania.
                  <br><br>
                  Jeśli obliczony procent Nocnego Finansowania jest dodatni, oznacza to, że odpowiednia kwota zostanie dodana (zasilona) do salda konta. Ujemny procent Nocnego Finansowania oznacza, że odpowiednia kwota będzie odjęta od salda konta.
                  <br><br>
                  Odpowiednie wartości procentowe Nocnego Finansowania, kwoty i związane z nimi godziny pracy na Transakcjach i Limitach, można znaleźć w sekcji Narzędzia, pod "Informacjami rynku". Aby obliczyć czy Twoje konto zostanie zwiększone lub obciążone Nocnym Finansowaniem, wystarczy po prostu pomnożyć procent Nocnego Finansowania przez wielkość transakcji. Czas realizacji procesu Nocnego Finansowania dla każdego kontraktu CFD został szczegółowo opisany w "Narzędzie Informacyjne Instrumentu" w części "Nocne Finansowanie(GMT)". Obliczona wartość i procent instrumentu nocnego finansowania obowiązuje przez 1 dzień. Kontrakty CFD, które są przedmiotem obrotu przez 5 dni w tygodniu, zostaną powiększone lub obciążone kwotą równą 3-krotności wyświetlonej wartości w ostatnim dniu podstawowego tygodnia handlu aktywami, ponieważ obejmuje ona cały weekend. Kwota Nocnego Finansowania jest kwotowana zgodnie z walutą CFD. Jeżeli jednak wartość waluty CFD, będąca inną walutą, różni się od waluty konta, zostanie ona przeliczona na walutę konta.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Obliczanie procentu Nocnego Finansowania podczas transakcji KUP (długa pozycja):
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Stopa procentowa drugiej waluty - Stopa procentowa waluty bazowej + Marża długa</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Obliczanie procentu Nocnego Finansowania podczas transakcji SPRZEDAJ (krótka pozycja):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Stopa procentowa drugiej waluty - Stopa procentowa waluty bazowej - Marża krótka</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Aby obliczyć Kwotę Nocnego Finansowania, należy pomnożyć procent przez wielkość transakcji:<br><br>Kwota Nocnego Finansowania = kwota transakcji X Procent Nocnego Finansowania
                      <br><br><br>
                      <u><b><u>Przykłady</u></b></u><br><br>
                      <b>Przykład I</b><br><br>
                      Ten przykład pokazuje sytuacje, w której różnica kursów międzybankowych jest WYŻSZA niż markup. W takich przypadkach Twoje konto zostanie obciążone podczas pozycji Długiej i zwiększone podczas pozycji Krótkiej:
                      <br><br>
                      <ul class="list-style-dashed mb-4">
                          <li>Instrument = EUR/USD (Euro do US Dollar)</li>
                          <li>Stopa procentowa EUR (waluta bazowa) (roczna) = -0,37% = -0,0037</li>
                          <li>Stopa procentowa USD (inna waluta) (roczna) = 1,08% = 0,0108</li>
                          <li>Różnica kursów międzybankowych = 1,45% = 0,0145</li>
                          <li>Długi Markup = 0,75% = 0,0075</li>
                          <li>Krótki Markup = 0,75% = 0,0075</li>
                          <li>Kwota transakcji wyrażona w innej walucie = 106.550 USD (100.000 EUR przy aktualnym kursie zamknięcia 1,0655)</li>
                      </ul>
                      Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Kwota Nocnego Finansowania = 106,550 × (-0.0000611) = -6.51 USD, co oznacza 6.51 USD za każdy dzień
                    <br><br><br>
                    Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Kwota Nocnego Finansowania = 106,550 × 0.00001944 = 2.07 USD dodane dziennie
                    <br><br><br>
                    <b>Przykład II</b><br><br>
                    Ten przykład pokazuje sytuacje, w której różnica kursów międzybankowych jest WYŻSZA niż markup, a Długi i Krótki markup, różnią się. W takich przypadkach Twoje konto zostanie obciążone co noc bez względu na kierunek Twojej pozycji:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Instrument = EUR/TRY (Euro vs. Lira Turecka)</li>
                       <li>Stopa procentowa EUR (waluta bazowa) (roczna) = -0,37% = -0,0037</li>
                       <li>Stopa procentowa TRY (inna waluta) (roczna) = 22,75% = 0,2275</li>
                       <li>Różnica kursów międzybankowych = 23.12% = 0.2312</li>
                       <li>Długi Markup = 0.75% = 0.0075</li>
                       <li>Krótki Markup = 14.00% = 0.14</li>
                       <li>Kwota transakcji wyrażona w innej walucie = 620,000 TRY (100.000 EUR przy aktualnym kursie zamknięcia 6.2000)</li>
                    </ul>
                    Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Procent Nocnego Finansowania</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Kwota Nocnego Finansowania = 620,000 × (-0.000663) = -411 TRY, co oznacza 411 TRY za każdy dzień (≅80 USD)
                        <br><br><br>
                        Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Procent Nocnego Finansowania</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Kwota Nocnego Finansowania = 620,000 × 0.000253 = 157 TRY, co oznacza 157 TRY dodane dziennie (≅30 USD)
                        <br><br><br>
                        <b>Przykład III</b><br><br>
                        Ten przykład pokazuje sytuacje, w której Różnica kursów międzybankowych jest NIŻSZA niż negatywny markup. W takich przypadkach Twoje konto zostanie obciążone podczas pozycji Długiej i zwiększone podczas pozycji Krótkiej.
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Instrument = USD/JPY (US Dollar do Jena Japońskiego)</li>
                           <li>Stopa procentowa USD (waluta bazowa) (roczna) = 1,08% = 1,08</li>
                           <li>Stopa procentowa JPY (inna waluta) (roczna) = -0,09% = -0,0009</li>
                           <li>Różnica kursów międzybankowych = -1,17% = -0,0117</li>
                           <li>Długi Markup = 0,75% = 0,0075</li>
                           <li>Krótki Markup = 0,75% = 0,0075</li>
                           <li>Kwota transakcji wyrażona w innej walucie = 10,341,000 JPY (100,000 USD przy aktualnym kursie zamknięcia 103.41)</li>
                        </ul>
                        Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Procent Nocnego Finansowania</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Kwota Nocnego Finansowania = 10,341,000 × 0.00001167 = 120.65 JPY dodane dziennie (≅1.1 USD)
                        <br><br><br>
                        Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Procent Nocnego Finansowania</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Kwota Nocnego Finansowania = 10,341,000 × (-0.0000533) = -551.52 JPY, co oznacza 551.52 JPY za każdy dzień (≅5.3 USD)
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Rozliczenia w ramach Nocnego Finansowania, mogą potrwać do 15 minut na koniec dnia handlowego, po czym konto zostanie odpowiednio zasilone lub obciążone.</p>`,
          table_titles: [
            "Instrument",
            "Dzienny Procent Nocnego Finansowania (Sprzedaż)",
            "Dzienny Procent Nocnego Finansowania (Kupno)",
            "Nocne Finansowanie (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Kontrakty CFD na Indeksy i Surowce i krypto CFD",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Nocne Finansowanie",
          content_before: `
              <p>
                    Podczas handlu na Indeksach, Surowcach i Krypto CFD z firmą iFOREX Europe, otwarte transakcje podlegają Nocnemu Finansowaniu pod koniec każdego dnia handlowego. Nocne Finansowanie, może powodować zwiększenie lub zmniejszenie kwoty i obliczane jest na podstawie odpowiednich stóp procentowych dla walut, w których instrument bazowy jest przedmiotem obrotu, plus mark-up. Marża w przypadku kryptowalut może być znacznie wyższa ze względu na ekstremalne warunki rynkowe kryptowalut. Zapoznaj się z poniższą tabelą, aby poznać najnowsze poziomy Nocnego Finansowania.
                    <br><br>
                    Jeśli obliczony procent Nocnego Finansowania jest dodatni, oznacza to, że odpowiednia kwota zostanie dodana (zasilona) do salda konta. Ujemny procent Nocnego Finansowania oznacza, że odpowiednia kwota będzie odjęta od salda konta.
                    <br><br>
                    Odpowiednie wartości procentowe Nocnego Finansowania, kwoty i związane z nimi godziny pracy na Transakcjach i Limitach, można znaleźć w sekcji Narzędzia, pod "Informacjami rynku". Aby obliczyć czy Twoje konto zostanie zwiększone lub obciążone Nocnym Finansowaniem, wystarczy po prostu pomnożyć procent Nocnego Finansowania przez wielkość transakcji. Czas realizacji procesu Nocnego Finansowania dla każdego kontraktu CFD został szczegółowo opisany w "Narzędzie Informacyjne Instrumentu" w części "Nocne Finansowanie(GMT)". Obliczona wartość i procent instrumentu nocnego finansowania obowiązuje przez 1 dzień. Kontrakty CFD, które są przedmiotem obrotu przez 5 dni w tygodniu, zostaną powiększone lub obciążone kwotą równą 3-krotności wyświetlonej wartości w ostatnim dniu podstawowego tygodnia handlu aktywami, ponieważ obejmuje ona cały weekend. Kwota Nocnego Finansowania jest kwotowana zgodnie z walutą CFD. Jeżeli jednak wartość waluty CFD, będąca inną walutą, różni się od waluty konta, zostanie ona przeliczona na walutę konta.
                    <br><br>
                    <u><b><u>Formula</u></b></u><br><br>
                    Obliczanie procentu Nocnego Finansowania podczas transakcji KUP (długa pozycja):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Stopa procentowa + Marża</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Obliczanie procentu Nocnego Finansowania podczas transakcji SPRZEDAJ (krótka pozycja):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Stopa procentowa - Marża</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Aby obliczyć Kwotę Nocnego Finansowania, należy pomnożyć procent przez wielkość transakcji:<br><br>Kwota Nocnego Finansowania = kwota transakcji X Procent Nocnego Finansowania
                <br><br><br>
                <u><b><u>Przykłady</u></b></u><br><br>
                <b>Przykład I</b><br><br>
                Ten przykład pokazuje sytuacje, w której różnica kursów międzybankowych jest WYŻSZA niż markup. W takich przypadkach Twoje konto zostanie obciążone podczas pozycji Długiej i zwiększone podczas pozycji Krótkiej:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrument = Brazylijska Ibovespa</li>
                   <li>Stopa procentowa Brazylianskiego Realu (BRL) (roczna) = 9,567% = 0,09567</li>
                   <li>Markup = 2,5% = 0,025</li>
                   <li>Wartość kwoty transakcji wyrażona w walucie = 127.380 BRL (2 kontrakty indeksowe przy obecnej stopie zamknięcia 63690 BRL za jeden kontrakt)</li>
                </ul>
 
                Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Kwota Nocnego Finansowania = 127,380 × (-0.0003351944) = -42.70 BRL, co oznacza 42.70 BRL za każdy dzień (≅13.58 USD)
                <br><br><br>
                Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Kwota Nocnego Finansowania = 127,380 × 0.00019630556 = 25 BRL dodane dziennie (≅7.95 USD)
                <br><br><br>
                <b>Przykład II</b><br><br>
                Ten przykład pokazuje sytuacje, w której Różnica kursów międzybankowych jest NIŻSZA niż markup. W takich przypadkach Twoje konto zostanie obciążone co noc bez względu na kierunek Twojej pozycji:
                <br><br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrument = Ropa (Crude Light WTI)</li>
                   <li>Stopa procentowa Dolara Amerykańskiego (USD) (roczna) = 1,08% = 0,0108</li>
                   <li>Markup = 2,5% = 0,025</li>
                   <li>Wartość kwoty transakcji wyrażona w walucie = 53.250 USD (1.000 baryłek przy bieżącym kursie zamknięcia 53,25 USD za baryłkę)</li>
                </ul>

                Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):
                  <br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Kwota Nocnego Finansowania = 53,250 × (-0.00009944) = -5.30 USD, co oznacza 5.30 USD za każdy dzień
                    <br><br><br>
                    Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Procent Nocnego Finansowania</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Kwota Nocnego Finansowania = 53,250 × (-0.00003944) = -2.10 USD, co oznacza 2.10 USD za każdy dzień
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Rozliczenia w ramach Nocnego Finansowania, mogą potrwać do 15 minut na koniec dnia handlowego, po czym konto zostanie odpowiednio zasilone lub obciążone.</p>`,
          table_titles: [
            "Instrument",
            "Dzienny Procent Nocnego Finansowania (Sprzedaż)",
            "Dzienny Procent Nocnego Finansowania (Kupno)",
            "Nocne Finansowanie (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Daty Kontraktów Rollover",
          content_before: `<p>
                      Każdy CFD, który oparty jest na przyszłej umowie (m.in. towary i indeksy) mają odpowiednią date rolowania.
                      <br><br>
                      Po osiągnięciu daty rolowania przez odpowiedni instrument, wszystkie otwarte pozycje CFD, zostaną przeniesione do następnej umowy, tak, że pozycje pozostaną otwarte wraz z nowym kontraktem.
                      <br><br>
                      Po wprowadzeniu rolowania, Otwarte Pozycje P/L (Zysk / Strata) będą wykazywać różnicę w cenie, między ceną wygaśnięcia kontraktu, a nowym kontraktem, a także obejmować mark-up spread. Wszystkie Zamówione Limity zostaną automatycznie dostosowane do nowej, przyszłej ceny kontraktu.
                      <br><br>
                      Na przykład, jeśli ostatnia cena kontraktu na Ropie WTI w lutym wynosi 50.125 USD, a cena rynkowa następnego kontraktu (marzec) w tym czasie wynosi 50.805 USD, wówczas poziom cen wszystkich limitów i transakcji zostanie zaktualizowany o 0,68 USD.
                      <br><br>
                      Daty rolowania na kontraktach, zależne są od instrumentu na którym handlujesz, a te przedstawione poniżej są jedynymi datami, odpowiednimi dla kontraktów CFD w iFOREX Europe:
                              </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Miesiąc kontraktu", "Data i godzina przeniesienia kontraktu (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Surowce", "Indeksy"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Akcje I ETF CFD",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Nocne Finansowanie",
          content_before: `<p>
                    Podczas handlu na Akcjach i ETF CFD z firmą iFOREX Europe, otwarte transakcje podlegają Nocnemu Finansowaniu pod koniec każdego dnia handlowego. Nocne Finansowanie, może powodować zwiększenie lub zmniejszenie kwoty i obliczane jest na podstawie odpowiednich stóp procentowych dla walut, w których instrument bazowy jest przedmiotem obrotu, plus mark-up. Zapoznaj się z poniższą tabelą, aby poznać najnowsze poziomy Nocnego Finansowania.
                    <br><br>
                    Jeśli obliczony procent Nocnego Finansowania jest dodatni, oznacza to, że odpowiednia kwota zostanie dodana (zasilona) do salda konta. Ujemny procent Nocnego Finansowania oznacza, że odpowiednia kwota będzie odjęta od salda konta.
                    <br><br>
                    Odpowiednie wartości procentowe Nocnego Finansowania, kwoty i związane z nimi godziny pracy na Transakcjach i Limitach, można znaleźć w sekcji Narzędzia, pod "Informacjami rynku". Aby obliczyć czy Twoje konto zostanie zwiększone lub obciążone Nocnym Finansowaniem, wystarczy po prostu pomnożyć procent Nocnego Finansowania przez wielkość transakcji. Czas realizacji procesu Nocnego Finansowania dla każdego kontraktu CFD został szczegółowo opisany w "Narzędzie Informacyjne Instrumentu" w części "Nocne Finansowanie(GMT)". Obliczona wartość i procent instrumentu nocnego finansowania obowiązuje przez 1 dzień. Kontrakty CFD, które są przedmiotem obrotu przez 5 dni w tygodniu, zostaną powiększone lub obciążone kwotą równą 3-krotności wyświetlonej wartości w ostatnim dniu podstawowego tygodnia handlu aktywami, ponieważ obejmuje ona cały weekend. Kwota Nocnego Finansowania jest kwotowana zgodnie z walutą CFD. Jeżeli jednak wartość waluty CFD, będąca inną walutą, różni się od waluty konta, zostanie ona przeliczona na walutę konta.
                    <br><br>
                    <u><b><u>Formula</u></b></u><br><br>
                    Obliczanie procentu Nocnego Finansowania podczas transakcji KUP (długa pozycja):
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Stopa procentowa + Marża</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Obliczanie procentu Nocnego Finansowania podczas transakcji SPRZEDAJ (krótka pozycja):

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Stopa procentowa - Marża</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Aby obliczyć Kwotę Nocnego Finansowania, należy pomnożyć procent przez wielkość transakcji:<br><br>Kwota Nocnego Finansowania = kwota transakcji X Procent Nocnego Finansowania
                <br><br><br>
                <u><b><u>Przykłady</u></b></u><br><br>
                <b>Przykład I</b><br><br>
                Ten przykład pokazuje sytuacje, w której różnica kursów międzybankowych jest WYŻSZA niż markup. W takich przypadkach Twoje konto zostanie obciążone podczas pozycji Długiej i zwiększone podczas pozycji Krótkiej:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Instrument = Gazprom (GAZP)</li>
                   <li>Stopa procentowa Rubla Rosyjskiego (RUB) (roczna) = 9,5% = 0,095</li>
                   <li>Markup = 5% = 0,05</li>
                   <li>Wartość kwoty transakcji wyrażona w walucie = 2 459 000 RUB (20 000 Akcji przy bieżącym kursie zamknięcia 122,95 RUB za akcję)</li>
                </ul>
      
                Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Kwota Nocnego Finansowania = 2,459,000 × (-0.0004) = -983.60 RUB, co oznacza 983.60 RUB za każdy dzień (≅17.52 USD)
                <br><br><br>
                Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Kwota Nocnego Finansowania = 2,459,000 × 0.000125 = 307.38 RUB dodane dziennie (≅5.48 USD)
                <br><br><br>
                <b>Przykład II</b><br><br>
                Ten przykład pokazuje sytuacje, w której Różnica kursów międzybankowych jest NIŻSZA niż markup. W takich przypadkach Twoje konto zostanie obciążone co noc bez względu na kierunek Twojej pozycji:<br>
                <br><br>
                <ul class="list-style-dashed mb-4">
                    <li>Instrument = Apple (AAPL)</li>
                    <li>Stopa procentowa Dolara Amerykańskiego (USD) (roczna) = 1,08% = 0,0108</li>
                    <li>Markup = 5% = 0,05</li>
                    <li>Wartość kwoty transakcji wyrażona w walucie = 70.600 USD (500 Akcji przy bieżącym kursie zamknięcia 141.20 USD za akcję)</li>
                </ul>

                Procent Nocnego Finansowania podczas pozycji KUP (Długa Pozycja):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Kwota Nocnego Finansowania = 70,600 × (-0.000169) = -11.93 USD, co oznacza 11.93 USD za każdy dzień
                <br><br><br>
                Procent Nocnego Finansowania podczas pozycji SPRZEDAJ (Krótka Pozycja):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Procent Nocnego Finansowania</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                Kwota Nocnego Finansowania = 70,600 × (-0.000109) = -7.70 USD, co oznacza 7.70 USD za każdy dzień
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Rozliczenia w ramach Nocnego Finansowania, mogą potrwać do 15 minut na koniec dnia handlowego, po czym konto zostanie odpowiednio zasilone lub obciążone.</p>`,
          table_titles: [
            "Instrument",
            "Dzienny Procent Nocnego Finansowania (Sprzedaż)",
            "Dzienny Procent Nocnego Finansowania (Kupno)",
            "Nocne Finansowanie (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dywidendy",
          content_before: `<p>
                    W przypadku wypłaty dywidend gotówkowych w odniesieniu do akcji CFD, korekta z tytułu dywidendy zostanie dokonana w celu zrównoważenia Bilansu konta Klienta, w stosunku do bazowych pozycji posiadanych przez Klienta na koniec dnia roboczego, poprzedzającego dzień dywidendy. Korektę dywidendy oblicza się na podstawie wielkości dywidendy, wielkość pozycji klienta i czy jest to poyzcja Kup bądź Sprzedaj, przy czym w pozycjach długich, korekta zostanie doliczona do zrównoważenia Balansu konta Klienta, a przy krótkich, zostanie odjęta od Salda Klienta. Dywidendy będą dodane bądź odjęte od Bilansu Klienta, poza godzinami obrotu akcji bazowych, a przed rozpoczęciem następnego dnia handlowego danej akcji oraz powinny być odpowiednie co do posiadaniej przez Klienta pozycji w momencie korekty dywidendy. W tym okresie, w celu utrzymania odpowiedniej wartości Kapitału Klienta do momentu otwarcia następnego dnia handlowego, Spółka skoryguje pozycje Klienta zgodnie z kwotą dywidendy obciążając bądź dodając do Salda Klienta.
                    <br><br>
                    <u><u>Przykład</u>:</u><br>
                    Coca-Cola wyda dywidendę w wysokości 0,35 USD na akcję.<br>
                    Termin dywidendy jest na 29 listopada, a data rozliczenia w iFOREX Europe jest na 28 listopada na 22:05 GMT.<br>
                    Cena zamknięcia przed rozliczeniem to 41.65.<br>
                    Do Konta Klienta, który posiada długą pozycję na 5000 akcji, zostanie doliczone 0,35 x 5000 = 1750 USD, jeśli jego umowa jest otwarta w dniu rozliczenia.
                    <br>
                    Podobna kwota będzie pobierana od salda klienta, w przypadku jeśli posiada pozycję krótką.
                    <br>
                    Cena akcji zostanie skorygowana po godzinach, od 41.65 do 41.30, która równa jest, ostatniej cenie akcji pomniejszonej o kwotę dywidendy.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Obecnie nie ma informacji o przyszłych dywidendach",
          table_titles: [
            "Akcja / ETF Fundusz",
            "Rynek",
            "Kwota Dywidendy",
            "Data I Czas (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Dywidendy akcji, podziały akcji i inne działania korporacyjne",
          content_before: `<p>
                  Działania korporacyjne są pewnymi wydarzeniami, które mają wpływ na wartość akcji spółki publicznej. O ile poniżej nie określono inaczej w odniesieniu do określonych Działań korporacyjnych, po wystąpieniu Działania korporacyjnego konkretnej akcji, iFOREX Europe zlikwiduje wszelkie otwarte pozycje odpowiednich CFD, w tym, w razie potrzeby, usunięcie wszelkich zleceń z limitem takich CFD.
                  <br><br>
                  Działania korporacyjne obejmują Oferty Praw, Wycofanie z obrotu, a także wszelkie inne zdarzenia, które w istotny sposób wpływają lub mogą mieć istotny wpływ na cenę akcji (w tym materiałne oświadczenia firmowe, przejęcia fuzje, upadłość itp).
                  <br><br>

                  <b>Dywidendy akcji</b><br>

            Dywidendy akcji na giełdzie nie zmieniają całkowitej wartości akcji dla ich posiadaczy, lecz zmieniają liczbę akcji i ich cenę.<br>
            Otrzymasz „Współczynnik korekty” za każdą posiadaną akcję.<br>
            Wszelkie Twoje otwarte transakcje i/lub zlecenia z limitem podczas daty i godziny dywidendy akcyjnej zostaną odpowiednio dostosowane pod względem ilości, ceny i powiązanych limitów (w tym saldo rachunku z tytułu wymaganych korekt zysków/strat, jeśli dotyczy).<br>
            Na przykład, w korekcie akcji ze współczynnikiem korekty 1,8, 1 akcja staje się 1,8 akcji po zdarzeniu, a cena jest dzielona przez 1,8, pozostawiając całkowitą wartość akcji bez zmian.<br>
            Przykład: 1 akcja o cenie 1.000 $ stanie się 1,8 akcji o cenie 555,56 $ po zdarzeniu: 1×1.000 $ = 1,8×555,56 $ = 1.000 $ wartości.<br><br>


                  <strong>
                  Szczegółowe zasady podziału akcji i odwrotnego podziału akcji
                  </strong>
                  <br>
                  Podziały akcji i odwrócone podziały akcji na giełdzie nie zmieniają całkowitej wartości akcji dla tych, którzy je posiadają, ale raczej zmieniają liczbę akcji i ich cenę. Te podziały są zwykle wdrażane, gdy cena akcji jest albo zbyt wysoka, albo zbyt niska. Jeśli otwarta transakcja/limit napotka podział akcji, jej kwota, kurs i poziom powiązanych limitów zostaną odpowiednio dostosowane (w tym saldo konta, ze względu na wymagane korekty ZS, jeśli dotyczą).
                  <br><br>
                  Na przykład w przypadku podziału 1:10 po zdarzeniu 1 akcja staje się 10 akcjami, a cena jest dzielona przez 10, pozostawiając całkowitą wartość akcji bez zmian. Na przykład 1 akcja wyceniona na 1000 USD stanie się 10 akcjami wycenionymi na 100 USD po zdarzeniu: 1x 1000 USD = 10 x 100 USD = wartość 1000 USD.
                  <br><br>
                  Poniżej znajduje się lista nadchodzących zdarzeń korporacyjnych:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Aktualnie nie ma informacji na temat przyszłych działań korporacyjnych",
          table_titles: ["Akcja / ETF Fundusz", "Rynek", "Type", "Data I Czas (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Raporty Finansowe",
          content_before: `<p>
                            Raporty finansowe to okresowe zgłoszenie dokonywane przez spółki publiczne w celu ogłoszenia ich wyników. Analizując kwartalne raporty finansowe, inwestorzy mogą analizować kondycję finansową firmy. Ogłoszenie zysków dla firmy, szczególnie dla popularnej firmy o wysokiej kapitalizacji rynkowej, może wpłynąć na jej ceny akcji, a jednocześnie spowodować znaczne wahania w dniach, w których publikowane są takie kwartalne raporty finansowe.
                            <br><br>
                            Z tego powodu maksymalna ekspozycja na odpowiednie akcje zostanie obniżona do 10,000 USD przez cały okres publikacji.
                          </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  